import { IBankIntegrationSettings } from '~/sharedInterfaces/SharedInterfaces';

// eslint-disable-next-line import/prefer-default-export
export const evaluateDefaultBankIntegrationSettings = (
  bankIntegrationSettings: IBankIntegrationSettings | undefined,
  defaultSettings: IBankIntegrationSettings
): IBankIntegrationSettings => {
  const title: string = bankIntegrationSettings?.title || defaultSettings.title;
  const loading: string = bankIntegrationSettings?.loading || defaultSettings.loading;
  const subTitle: string = bankIntegrationSettings?.subTitle || defaultSettings.subTitle;
  const buttonText: string = bankIntegrationSettings?.buttonText || defaultSettings.buttonText;
  const onSuccessText: string =
    bankIntegrationSettings?.onSuccessText || defaultSettings.onSuccessText;
  const tooltipText: string = bankIntegrationSettings?.tooltipText || defaultSettings.tooltipText;
  return { title, subTitle, buttonText, onSuccessText, tooltipText, loading };
};
